import { RenderFunc } from '../types/RenderFunc';

export const renderApprovalOfAgreement: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue:
      typeof oldValue === 'boolean'
        ? (oldValue && 'Утверждено') || 'Отказано'
        : (typeof oldValue === 'string' && oldValue) || '',
    renderedNewValue:
      typeof newValue === 'boolean'
        ? (newValue && 'Утверждено') || 'Отказано'
        : (typeof newValue === 'string' && newValue) || '',
  };
};
